import styled from 'styled-components';

import { TextButton as TextButtonComponent } from '@xing-com/button';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale080,
  spaceL,
  spaceS,
  xdlColorDisabledSoft,
} from '@xing-com/tokens';
import { BodyCopy as BodyCopyComponent } from '@xing-com/typography';

export const SortingContainer = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spaceS};
  margin-bottom: ${spaceL};
`;

export const BodyCopy = styled(BodyCopyComponent)<{ $isDisabled: boolean }>`
  margin: 0;
  ${({ $isDisabled }) => $isDisabled && `color: ${xdlColorDisabledSoft};`}

  @media ${mediaSmallOrTiny} {
    font-size: ${scale080};
  }
`;

export const TextButton = styled(TextButtonComponent)`
  @media ${mediaSmallOrTiny} {
    font-size: ${scale080};
  }
`;
